import { render } from "./RegisterModalContent.vue?vue&type=template&id=7ef4bd6f&scoped=true"
import script from "./RegisterModalContent.vue?vue&type=script&lang=js"
export * from "./RegisterModalContent.vue?vue&type=script&lang=js"

import "./RegisterModalContent.vue?vue&type=style&index=0&id=7ef4bd6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef4bd6f"]])

export default __exports__